<template>
  <div>
    <Navbar/>
    <!-- <SlideBar/>
    <About/>
    <Logo/> -->
    <Homepageapi/>
    <!-- <About/> -->
    <!-- <Footer/> -->
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
// import SlideBar from '@/components/home/SlideBar'
// import About from '@/components/home/AboutUS'
// import Feature from '@/components/home/Feature'
// import Logo from '@/components/home/Logo2'
// import Support from '@/components/home/Support'
// import Footer from '@/components/home/Footer'
import Homepageapi from '@/components/home/HomepageApi'
export default {
  components: {
    Navbar,
    // SlideBar,
    // About,
    // Feature,
    // Logo,
    // Support,
    // Footer,
    Homepageapi
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/home/HomePage.vue